import { useState } from 'react';
import { Autocomplete, Box, IconButton, CircularProgress, Popover, TextField, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';

AddUsersToTicket.propTypes = {
  newUsers: PropTypes.array,
  setNewUsers: PropTypes.func,
  possibleUsers: PropTypes.array,
};

export default function AddUsersToTicket({ newUsers, setNewUsers, possibleUsers }) {
  const [open, setOpen] = useState(null);

  const updateUsers = (newValue) => {
    const updatedUsers = newValue.map((item) => {
      if (typeof item === 'string') return { id: item, value: item };
      return item;
    });
    setNewUsers(updatedUsers);
  };

  return (
    <>
      <Tooltip title="Add user">
      <IconButton
        size="small"
        onClick={(event) => setOpen(event.currentTarget)}
        color="white"
        sx={{
          ml: 0.5,
          height: 32,
          width: 32,
          minWidth: 0,
          backgroundColor: 'primary.main',
          '&:hover': { backgroundColor: 'primary.dark' },
          verticalAlign: 'middle',
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Tooltip>

      <Popover
        open={open !== null}
        anchorEl={open}
        onClose={() => setOpen(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { p: 0, mt: 1.5, ml: 0.75 } } }}
      >
        <Box sx={{ p: 2, maxWidth: 600, minWidth: 600, overflow: 'hidden' }}>
          {possibleUsers ? (
            <Autocomplete
              multiple
              id="tags-outlined"
              options={possibleUsers || []}
              getOptionLabel={(option) => `${option.value} - ${option.id}`}
              value={newUsers}
              onChange={(event, newValue) => updateUsers(newValue)}
              freeSolo
              disableClearable
              filterSelectedOptions
              renderTags={() => null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="CC additional users"
                  placeholder="Add user"
                  fullWidth={false}
                  sx={{ maxWidth: 570, minWidth: 570 }}
                  autoComplete="off"
                />
              )}
            />
          ) : (
            <CircularProgress />
          )}
        </Box>
      </Popover>
    </>
  );
}
